module.exports = __webpack_public_path__ + "resources/img/img_secureguard_am5_m_en.a98c809d6c9528b3871eb7117cdd614e.png";